export const calculateProgress = (value, containerSize) => {
  if (!containerSize) return 0;
  return parseFloat( (((-value * 100) / containerSize) / 100 ).toFixed(3));
};